// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"a1872be5","194":"253e3900","319":"44a975d7","453":"96c1c06d","555":"17c08eee"}[chunkId] + ".chunk.js";
};